import template from './employee_dashboard.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeDashboardViewModel
{
	constructor(page)
	{
		this.page = page;
		this.leave_count = ko.observableArray();
		this.my_leave_requests = ko.observableArray();
		this.birthdays = ko.observableArray();
		this.on_leave = ko.observableArray();
		this.employee_id = ko.observable('');
		this.pending_requests_count = ko.observable(0);
		this.pending_wizard_count = ko.observable(0);
		this.all_leave = ko.observableArray();
		this.leave_limit_over = ko.observable(0);
		this.surveys = ko.observableArray();
		this.events = ko.observableArray(); 
		this.available_surveys = ko.observableArray([]);
		this.completed_surveys = ko.observableArray([]);
		this.notifications = ko.observableArray([]);
		this.available_surveys_limit_over = ko.observable(0);
		this.notifications_limit_over = ko.observable(0);
		this.nothing_to_do = ko.observable(false);
		this.holidays = ko.observableArray([]);
	}

	// approve leave section
	async add_leave_modal()
	{
		let employee_id = Utils.get_local_storage_nullable('employee_id');
		await Grape.dialog.open('EmployeeLeaveEntry', { employee_id: employee_id, employment_info: this.page.bindings.employment_info });
		this.page.updateData();
	}

	// approve leave section
	async log_time()
	{
		let employee_id = Utils.get_local_storage_nullable('employee_id');
		await Grape.dialog.open('LogTime', { employee_id: employee_id });
		this.page.updateData();
	}

	async cancel_leave(data)
	{
		let d = data;
		let response = await Grape.alerts.confirm({type: 'warning', message: tr('Are you sure you want to cancel this leave request?'), title: tr('Warning')});

		if (response)
		{
			let data = ko.toJS(d);
			let res = await Grape.fetches.postJSON('/leave/cancel_leave', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({title: tr('Success'), message: tr('Successfully cancelled leave.'), type: 'success'});
				this.page.updateData();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		};
	};

	async dismiss_leave(data)
	{
		let d = data;
		let response = await Grape.alerts.confirm({type: 'warning', message: tr('Are you sure you want to dismiss this leave request?'), title: tr('Warning')});

		if (response)
		{
			let data = ko.toJS(d);
			let res = await Grape.fetches.postJSON('/leave/dismiss_leave', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({title: tr('Success'), message: tr('Successfully dismissed leave.'), type: 'success'});
				this.page.updateData();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		};
	};

	// approve leave section
	async show_notification(data)
	{
		let notif_data = ko.toJS(data);
		await Grape.dialog.open('OpenNotification', { data: notif_data });
		this.page.updateData();
	};
}

class EmployeeDashboard
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new EmployeeDashboardViewModel(this);
	}

	async init()
	{
		// udpate the page title
		document.title = tr('Dashboard');
		window.current_page_title(tr('Dashboard'));

		this.viewModel.employee_id(Utils.get_local_storage_nullable('employee_id'));

		// align employee photo
		alignEmployeePhoto(Utils.get_local_storage_nullable('employee_id'), '#employee_photo');
		
		document.addEventListener('DOMContentLoaded', () => {
			const gridContainer = document.querySelector('.savanna-dashboard-grid');
			const gridColumns = gridContainer.querySelectorAll('.grid-col');
			const gridItems = gridContainer.querySelectorAll('.grid-item');
			
			// Set the width of each column
			gridColumns.forEach((column) => {
				column.style.width = `${100 / gridColumns.length}%`;
			})
			
			// Distribute grid items across columns
			let columnIndex = 0;
			gridItems.forEach((item) => {
				let currentColumn = gridColumns[columnIndex];
				currentColumn.appendChild(item);
				columnIndex = (columnIndex + 1) % gridColumns.length;
			})
		})
	}

	async updateData()
	{
		Utils.refresh_data_visible_roles();
		let result_counter = 0;

		//calendar colors
		await this.load_calendar_colors();

		//load holidays
		await this.load_holidays()
		
		// load leave entries
		await this.load_leave();

		// get the birthdays
		result_counter += await this.load_birthdays();

		// load manager's leave request entries
		await this.load_pending_leave_requests();
		await this.load_wizard_not_done();

		// load current employees on leave
		result_counter += await this.load_currently_on_leave();

		// load surveys
		result_counter += await this.load_survey_list();

		result_counter += await this.load_events_list();

		// load notifications
		result_counter += await this.load_notifications();

		// when one item has information - we show it in full length
		if (result_counter == 1)
			$('.savanna-dashboard-grid .grid-col').css('width', '100%');
		else
			$('.savanna-dashboard-grid .grid-col').css('width', '50%');

		if (this.viewModel.notifications().length==0 && this.viewModel.available_surveys().length==0 && this.viewModel.on_leave().length ==0 && this.viewModel.birthdays().length==0 && this.viewModel.events().length ==0)
			this.viewModel.nothing_to_do(true);
	};

	async load_leave()
	{
		let employee_id = this.viewModel.employee_id();
		let res = await Grape.fetches.postJSON('/leave/get_leave_taken_and_requests', { employee_id });
		if (res && res?.all_finalized_leave)
			this.parse_leave(res);

		this.viewModel.my_leave_requests.removeAll(); // clear

		// My leave requests pending

		let options = { 
			table: 'v_leave_requests_pending',
			schema: 'savanna',
			limit: 100,
			sortfield: 'from_date',
			sortorder: 'ASC',
			filter: [{ value: employee_id, op: '=', field: 'employee_id' }]
		};

		res = await Grape.fetches.getJSON('/api/record', options);
		if (res.records)
			this.viewModel.my_leave_requests(res.records);

		// My leave requests cancellations pending

		let option = {
			table: 'v_leave_finalized_cancellation_requests_pending',
			schema: 'savanna',
			limit: 100,
			sortfield: 'from_date',
			sortorder: 'ASC',
			filter: [{ value: employee_id, op: '=', field: 'employee_id' }]
		}

		res = await Grape.fetches.getJSON('/api/record', option);
		if (res?.records?.length)
			this.viewModel.my_leave_requests(res.records);
	}

	async load_currently_on_leave()
	{
		let employee_id = this.viewModel.employee_id();
		// get the people who are on leave
		let res = await Grape.fetches.postJSON('/leave/get_dashboard_on_leave_list', { employee_id: employee_id });
		this.viewModel.on_leave.removeAll();

		if (res.status === 'OK')
		{
			var resultinfo = res.dashboard_on_leave_list;

			// there are more people on leave than our list limit
			if (resultinfo[0].count > resultinfo[0].limit)
				this.viewModel.leave_limit_over(resultinfo[0].count - resultinfo[0].limit);
			else
				this.viewModel.leave_limit_over(0);

			if (resultinfo[0].leave_info != null)
			{
				for (let i = 0; i < resultinfo[0].leave_info.length; i++)
				{
					alignEmployeePhotoSize(resultinfo[0].leave_info[i].employee_id, '#on_leave_employee_photo_' + resultinfo[0].leave_info[i].employee_id, 90);
				}

				this.viewModel.on_leave(resultinfo[0].leave_info);
				return 1;
			}
			else
			{
				this.viewModel.on_leave.removeAll();
				return 0;
			}
		}
		else if (res.status == 'ERROR')
		{
			// permission denied
		}
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		return 0;
	}

	async load_pending_leave_requests()
	{
		let employee_id = this.viewModel.employee_id();
		try {
			let options = {
				table: 'v_number_requests_to_approve_by_manager',
				schema: 'savanna',
				limit: 1,
				filter: [{ value: employee_id, op: '=', field: 'manager_id' }]
			}

			let res = await Grape.fetches.getJSON('/api/record', options );

			if (res.records && res.records[0] && res.records[0].cnt !== null && res.records[0].cnt !== undefined)
				this.viewModel.pending_requests_count(res.records[0].cnt);
			else
				this.viewModel.pending_requests_count(0);

		} catch (err) {
			console.error('Error loading pending leave requests:', err);
		}
	}

	async load_wizard_not_done()
	{
		let result = await Grape.fetches.getJSON('/wizard/get_wizard_not_done_count');
		if (result.count > 0)
			this.viewModel.pending_wizard_count(result.count);
	}

	async load_birthdays()
	{
		let options = {
			table: 'v_employee_birthdays_today',
			schema: 'savanna',
			limit: 100,
			sortfield: 'surname',
			sortorder: 'ASC'
		}

		let res = await Grape.fetches.getJSON('/api/record', options);
		if (res?.records?.length)
		{
			for (let i = 0; i < res.records.length; i++)
			{
				alignEmployeePhotoSize(res.records[i].employee_id, '#birthday_employee_photo_' + res.records[i].employee_id, 90);
			}

			this.viewModel.birthdays(res.records);
			return 1;
		}
		else
		{
			this.viewModel.birthdays.removeAll();
			return 0;
		}
	}

	async load_holidays()
	{
		let holiday_res = await Grape.fetches.postJSON('/leave/get_holidays', {});

		if (holiday_res?.get_holidays)
			this.viewModel.holidays(holiday_res.get_holidays);

		else
			this.viewModel.holidays.removeAll();
	}

	async load_events_list()
	{
		let options = {
			table: 'events',
			schema: 'public',
			limit: 1000, 
			filter: [
				{ value: new Date().toISOString().split('T')[0], op: '=', field: 'event_date'}
			]
		}

		let res = await Grape.fetches.getJSON('api/record', options );
		this.viewModel.events(res.records); 
	}

	async load_calendar_colors()
	{
		let res = await Grape.fetches.postJSON('/general/get_leave_color_combinations', {});
		generateCSScolorCombinations(res);
	}

	async load_survey_list()
	{
		let limit = 7;
		let tmp_available_surveys = [];
		let tmp_completed_surveys = [];
		let user_id = localStorage.getItem('session_id');
		let employee_id = Utils.get_local_storage_nullable('employee_id');

		let res_options = {
			table: 'v_surveys',
			schema: 'savanna',
			limit: 5000,
			filter: [
				{ value: employee_id, operand: '=', field: 'employee_id' }, {
					value: [ 'Sent', 'Read' ],
					operand: 'IN',
					field: 'survey_status'
				}, { value: true, operand: '=', field: 'active' }
			]
		}

		let res_surveys = await Grape.fetches.getJSON('/api/record', res_options);
		res_surveys.records = res_surveys.records || [];

		if (res_surveys.records.length > limit)
			this.viewModel.available_surveys_limit_over(res_surveys.records.length - limit);
		else
			this.viewModel.available_surveys_limit_over(0);

		for (let i = 0; i < res_surveys.records.length; i++)
		{
			let boolCheck = false;
			if (res_surveys.records.length == limit)
				break;

			if (res_surveys.records[i].public == false)
			{
				let options = {
					table: 'v_anonymous_surveys',
					schema: 'savanna',
					limit: 5000,
					filter: [
						{ value: res_surveys.records[i].survey_id, op: '=', field: 'survey_id' },
						{ value: user_id, op: '=', field: 'user_id' },
						{ value: true, op: '=', field: 'active' }
					]
				}

				let res_anon_surveys = await Grape.fetches.getJSON('/api/record', options);
				if (res_anon_surveys?.records?.length > 0)
				{
					boolCheck = true;

					// SET anonymous survey status here.
					res_anon_surveys.records[0].survey_status = res_surveys.records[i].survey_status;

					if (res_anon_surveys.records[0].percentage_complete < 100)
						tmp_available_surveys.push(res_anon_surveys.records[0]);
					else
						tmp_completed_surveys.push(res_anon_surveys.records[0]);

					this.viewModel.available_surveys(tmp_available_surveys);
					this.viewModel.completed_surveys(tmp_completed_surveys);
				}
			}

			if (boolCheck == false && res_surveys.records[i].public == true)
			{
				// LOGIC: Group completed or available surveys
				if (res_surveys.records[i].percentage_complete < 100)
					tmp_available_surveys.push(res_surveys.records[i]);
				else
					tmp_completed_surveys.push(res_surveys.records[i]);

				this.viewModel.available_surveys(tmp_available_surveys);
				this.viewModel.completed_surveys(tmp_completed_surveys);
			}
		} 

		if (this.viewModel.available_surveys().length)
			return 1;
		else
			return 0;
	}

	async load_notifications()
	{
		let limit = 3;
		let employee_id = this.viewModel.employee_id();
		this.viewModel.notifications([]);
		let result = await Grape.fetches.postJSON('/notifications/get_notifications', { employee_id: employee_id });

		if (result?.notifications?.length)
		{
			if (result.notifications.length > limit)
				this.viewModel.notifications_limit_over(result.notifications.length - limit);
			else
				this.viewModel.notifications_limit_over(0);

			for (let i = 0; i < result.notifications.length; i++)
			{
				if (i == limit) break;

				let employee = result.notifications[i].recipients.filter(recipient => recipient.employee_id == employee_id);
				
				if (employee.length > 0)
					result.notifications[i].is_read = employee[0].notifications_status == 'Read';
				
					this.viewModel.notifications.push(result.notifications[i]);
			}
			return 1;
		}
		else
			return 0;
	}

	parse_finalized_leave(res)
	{
		var parsed_dates = new Array();
		for (var a = 0; a < res.length; a++)
		{
			for (var b = 0; b < res[a].dates_included.length; b++)
			{
				parsed_dates[getDate(res[a].dates_included[b])] = { 'date': new Date(res[a].dates_included[b]), 'type': 'use_css_class', 'name': res[a].leave_type + ' (Finalized) ', 'css_class': res[a].css_class_name, 'holiday_type': 'Leave' };
			}
		}
		return parsed_dates;
	}

	parse_holiday_dates(res)
	{
		var holiday_dates = [];
		if (res != null) {
			for (let a = 0; a < res.length; a++) {
				if (!holiday_dates[getDate(res[a].holiday_date)])
					holiday_dates[getDate(res[a].holiday_date)] = {
						'date': new Date(res[a].holiday_date),
						'name': res[a].description,
						'css_class': res[a].css_class_name,
						'holiday_type': res[a].holiday_type,
						'type': 'holiday'
					};
			}
		}
		return holiday_dates
	}

	parse_finalized_dates(date_array)
	{
		var parsed_dates = new Array();
		for (var a = 0; a < date_array.length; a++)
		{
			parsed_dates[getDate(date_array[a])] = { 'date': new Date(date_array[a]), 'type': 'use_css_class', 'name': 'Requested Leave day', 'css_class': 'request_date', 'holiday_type': 'Request' };
		}
		return parsed_dates;
	}

	parse_leave(res)
	{
		this.viewModel.all_leave(res);

		// show the finalized leave
		var finalized_leave_dates = new Array();
		finalized_leave_dates = this.parse_finalized_leave(res.all_finalized_leave);

		res.all_leave_to_approve.temp_event_dates = new Array(); // this is the array that will store ALL dates in the calendar

		// show the leave to approve - But skip the rejected leave reave requests 
		for (let b = 0; b < res.all_leave_to_approve.length; b++)
		{
			// Skip rejected leave requests
			if (res.all_leave_to_approve[b].approved === 'rejected') continue;
			
		
			res.all_leave_to_approve.temp_event_dates = res.all_leave_to_approve.temp_event_dates.concat(res.all_leave_to_approve[b].dates_included);
		} 

		// combine the all_leave_to_approve , holidays and finalized leave
		let requested_dates = new Array();
		requested_dates = this.parse_finalized_dates(res.all_leave_to_approve.temp_event_dates);

		let holiday_dates = new Array();
		holiday_dates = this.parse_holiday_dates(this.viewModel.holidays());

		res.all_leave_to_approve.temp_event_dates = eventDates;
		res.all_leave_to_approve.temp_event_dates = merge_two_date_objects(res.all_leave_to_approve.temp_event_dates, finalized_leave_dates);
		res.all_leave_to_approve.temp_event_dates = merge_two_date_objects(res.all_leave_to_approve.temp_event_dates, requested_dates);
		res.all_leave_to_approve.temp_event_dates = merge_two_date_objects(res.all_leave_to_approve.temp_event_dates, holiday_dates);

		$('#dashboard_datepicker').datepicker('remove');

		let tmp = $('#dashboard_datepicker').datepicker({
			format: 'yyyy-mm-dd',
			todayHighlight: true,
			appendTo: 'body',
			beforeShowDay: function (date) {
				return setCalendarHighlightDates(date, res.all_leave_to_approve.temp_event_dates);
			}
		});
	}
};

export default
{
	route: '[/]employee/dashboard',
	page_class: EmployeeDashboard,
	template: template,
	template_filename: 'translation/employee_dashboard'
};
